import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "text-left pb-6" }
const _hoisted_2 = {
  key: 0,
  class: "text-md font-bold mb-4"
}
const _hoisted_3 = {
  key: 1,
  class: "text-gray-500 text-sm text-left"
}
const _hoisted_4 = {
  key: 2,
  class: "flex flex-col gap-3"
}
const _hoisted_5 = { class: "text-start" }
const _hoisted_6 = { class: "font-bold text-sm" }
const _hoisted_7 = { class: "text-xs font-normal text-gray-500" }
const _hoisted_8 = { class: "text-sm mt-1 text-left" }

interface Observation {
  author: string
  timestamp: string
  text: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ObservationList',
  props: {
    observations: {},
    showTitle: { type: Boolean, default: true }
  },
  emits: ["delete"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showTitle)
      ? (_openBlock(), _createElementBlock("h3", _hoisted_2, "Observações"))
      : _createCommentVNode("", true),
    (_ctx.observations.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Nenhuma observação registrada. "))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.observations, (obs, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "bg-gray-100 p-3 rounded-lg flex justify-between items-start"
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("p", _hoisted_6, [
                  _createTextVNode(_toDisplayString(obs.author) + " ", 1),
                  _createElementVNode("span", _hoisted_7, " | " + _toDisplayString(obs.timestamp), 1)
                ]),
                _createElementVNode("p", _hoisted_8, _toDisplayString(obs.text), 1)
              ])
            ]))
          }), 128))
        ]))
  ]))
}
}

})